/*
 * home (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import { Page } from "@timeprox/react/ui"
import { NamePicker } from "../components/name-picker"

export const Route = createFileRoute("/")({ component: HomePage })

function HomePage() {
	return (
		<Page>
			<NamePicker />
		</Page>
	)
}
